import ReactGA from "react-ga4";
import { useCookieConsentContext } from "@use-cookie-consent/react";
import { useAppConfig } from "@ct-react/core";

const CookieConsentProvider = () => {

  const { env, gaTag } = useAppConfig();
  const { consent } = useCookieConsentContext();

  (consent.thirdParty && !!gaTag) && ReactGA.initialize(gaTag, { testMode: env === "development" });
  return null;

}

export default CookieConsentProvider;
